@use "variables" as *;
@use "../../../../shared/styles/dropdown.scss";

.dropdown {
  @include dropdown.dropdown;
}
